<template>
  <div class="fieldBody">
    <div v-for="(item, index) in contentList" :key="index">
      <amp-text v-if="item.type === 'text'" :item="item"></amp-text>
      <amp-image v-else-if="item.type === 'image'" :item="item"></amp-image>
      <amp-iframe v-else-if="item.type === 'iframe'" :item="item"></amp-iframe>
      <amp-blockquote v-else-if="item.type === 'blockquote'" :item="item"></amp-blockquote>
      <template v-if="getBodyOptions.alsoRead.enable" v-for="(article, articleIndex) in alsoReadArticles">
        <amp-also-read :data-index="index" :article="article" v-if="article.insertAtIndex === index && article.isIndexAvailable" :key="articleIndex"></amp-also-read>
      </template>
    </div>
  </div>
</template>
<script>
  import { mapState } from 'vuex'
  import get from 'lodash/get'
  import forEach from 'lodash/forEach'
  import assignIn from 'lodash/assignIn'
  import reduce from 'lodash/reduce'
  
  export default {
    name: 'amp-field-body',
    props: {
      bodyOptions: Object,
    },
    components: {
      AmpText: () => import('components/article/amp/AmpText'),
      AmpImage: () => import('components/article/amp/AmpImage'),
      AmpIframe: () => import('components/article/amp/AmpIframe'),
      AmpAlsoRead: () => import('components/article/amp/AmpAlsoRead'),
      AmpBlockquote: () => import('components/article/amp/AmpBlockquote'),
    },
    computed: {
      ...mapState([
        'activeNID',
      ]),
      node() {
        return this.$store.getters.node(this.activeNID)
      },
      contentList() {
        let counter = {}
        forEach(get(this, 'node.contentList', []), (value) => {
          counter = assignIn(counter, {[`${value.type}`]: get(counter, `[${value.type}]`, 0) + 1})
          value.itemTypeIndex = counter[`${value.type}`]
        })
        return get(this, 'node.contentList', [])
      },
      relatedArticles() {
        return get(this, 'node.related_articles', [])
      },
      getBodyOptions() {
        return assignIn({
          countDown: false,
          photoOverlay: false,
          inlineNewsletter: true,
          hideParagraphArrow: false,
          alsoRead: {
            enable: true,
            alsoReadLayout: [4, 3, 4, 4, 4],
            insertPosition: [6, 9, 12, 15, 18],
          },
        }, this.bodyOptions)
      },
      alsoReadArticlesIndexesAvailable() {
        const bodyOptionPositionsArray = get(this, 'getBodyOptions.alsoRead.insertPosition', [])

        // separate as PASS and FAIL to see which ones to place at the bottom(fail) or insert into the content(pass)
        const [pass, fail] = reduce(bodyOptionPositionsArray, (result, position) => {
          result[(position - 1 <= this.contentList.length) ? 0 : 1].push(position - 1) // less 1, since using Index to match to content list
          return result
        }, [[], []])

        const indexesAvailableForAlsoRead = {pass, fail}
        return indexesAvailableForAlsoRead
      },
      alsoReadArticles() {
        const isEnabled = get(this, 'getBodyOptions.alsoRead.enable', false)
        const alsoReadArticles = []

        if (isEnabled) {
          const bodyOptionPositionsArray = get(this, 'getBodyOptions.alsoRead.insertPosition', [])
          const bodyOptionsLayoutsArray = get(this, 'getBodyOptions.alsoRead.alsoReadLayout', [])
          const indexesAvailablePass = get(this, 'alsoReadArticlesIndexesAvailable[pass]', [])

          // Go through related articles and set additional details for the Also Read articles
          forEach(this.relatedArticles, (article, articleIndex) => {
            let getLayoutType = 4
            let getInsertAtIndex = this.contentList.length
            let getIsIndexAvailable = false

            // Assign corresponding layout type to the matching index in the Layouts array
            forEach(bodyOptionsLayoutsArray, (type, typeIndex) => {
              if (articleIndex === typeIndex) {
                getLayoutType = type
                return false
              }
              return true
            })

            // Assign the position(converted as index) to insert in Contentlist: Match the corresponding article index to the matching index in the Positions array and assign it the Position (converted as index)
            forEach(bodyOptionPositionsArray, (position, positionIndex) => {
              if (articleIndex === positionIndex) {
                getInsertAtIndex = position - 1 // less 1, since using Index to match to content list
                return false
              }
              return true
            })

            // Check if the index that will be inserted in is part of the PASS index availables
            forEach(indexesAvailablePass, (Available) => {
              if (getInsertAtIndex === Available) {
                getIsIndexAvailable = true
                return false
              }
              return true
            })

            // To avoid H Tag
            while (get(this, `contentList[${getInsertAtIndex}].content.html`) && this.contentList[getInsertAtIndex].content.html.match(/<h[1-5]>(.*)?<\/h[1-5]>/)) getInsertAtIndex -= 1

            const alsoReadDetails = {
              node: article,
              layoutType: getLayoutType,
              insertAtIndex: getInsertAtIndex,
              isIndexAvailable: getIsIndexAvailable,
              isLast: articleIndex === this.relatedArticles.length - 1,
            }

            alsoReadArticles.push(alsoReadDetails)
          })
        }
        return alsoReadArticles
      },
    },
  }
</script>

<style lang="scss" scoped>
  .fieldBody {
    position: relative;
    margin-top: rem-calc(18);
    &::before {
      background-image: url('/static/svg/raw/icon_arrow_right1.svg');
      background-size: contain;
      content: "";
      display: block;
      height: rem-calc(25);
      width: rem-calc(15);
      position: absolute;
      left: 0;
      top: rem-calc(0);
    }
  }
</style>


// WEBPACK FOOTER //
// AmpFieldBody.vue?6ed81bcb